import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'vehicles.form.exception.createException.header.title' }),
    description: translate({ id: 'vehicles.form.exception.createException.header.description' }),
  }))

  return api
}
